// Core shared logic for promo-tiles modules (slots and slider)
let resolveRoot = (el)=>{
    var _el_closest;
    // fallback to the nearest .shopify-section, then document.body
    const section = el === null || el === void 0 ? void 0 : (_el_closest = el.closest) === null || _el_closest === void 0 ? void 0 : _el_closest.call(el, '.shopify-section');
    if (section instanceof HTMLElement) return section;
    const fallback = document.querySelector('.shopify-section');
    return fallback instanceof HTMLElement ? fallback : document.body;
};
// Per-root subscribers (both modules can register)
const subscribers = new WeakMap();
// Coalesce relayouts to once-per-frame per root
const pending = new Set();
let raf = 0;
const schedule = (root)=>{
    pending.add(root);
    if (raf) return;
    raf = requestAnimationFrame(()=>{
        for (const r of pending){
            const set = subscribers.get(r);
            if (set) for (const cb of set)cb(r);
        }
        pending.clear();
        raf = 0;
    });
};
// Global listeners: ensure we only bind once, even if init runs many times
let globals = null;
const onCollectionRendered = (e)=>{
    var _e_detail;
    var _e_detail_el;
    const el = (_e_detail_el = (_e_detail = e.detail) === null || _e_detail === void 0 ? void 0 : _e_detail.el) !== null && _e_detail_el !== void 0 ? _e_detail_el : document.querySelector('#product-grid');
    const root = resolveRoot(el !== null && el !== void 0 ? el : null);
    schedule(root);
};
export const ensureGlobalBindings = (opts)=>{
    if (opts === null || opts === void 0 ? void 0 : opts.getRootFromAny) resolveRoot = opts.getRootFromAny;
    if (globals) return; // already bound
    globals = new AbortController();
    const { signal  } = globals;
    document.addEventListener('collection:rendered', onCollectionRendered, {
        signal
    });
};
export const subscribe = (root, cb)=>{
    let set = subscribers.get(root);
    if (!set) {
        set = new Set();
        subscribers.set(root, set);
    }
    set.add(cb);
    return ()=>{
        if (set) set.delete(cb);
    };
};
export const relayout = (el)=>{
    const root = resolveRoot(el !== null && el !== void 0 ? el : document.querySelector('#product-grid'));
    schedule(root);
};
export const resetCore = ()=>{
    globals === null || globals === void 0 ? void 0 : globals.abort();
    globals = null;
    pending.clear();
// subscribers live in a WeakMap; GC will handle roots as they detach
};
